import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  var navigate = useNavigate();
  var token = localStorage.getItem('token');
  var isLoggedIn = false;
  try {
    if (token) {
      var payload = JSON.parse(atob(token.split('.')[1]));
      isLoggedIn = payload.exp * 1000 > Date.now();
    }
  } catch (e) {}

  var f = "'Outfit', -apple-system, BlinkMacSystemFont, sans-serif";

  var navLink = function(label, href, external) {
    return React.createElement('a', {
      key: label, href: href,
      target: external ? '_blank' : undefined,
      rel: external ? 'noopener noreferrer' : undefined,
      className: 'nav-link-hover',
      style: { fontSize: 13, fontWeight: 500, color: 'rgba(255,255,255,0.5)', textDecoration: 'none', transition: 'color 0.2s' },
    }, label);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0a0a0a', color: '#fafafa', fontFamily: f }}>

      {/* Responsive styles */}
      <style>{`
        .nav-link-hover:hover { color: #fff !important; }
        .footer-link:hover { color: rgba(255,255,255,0.6) !important; }
        .btn-hover:hover { transform: translateY(-1px); box-shadow: 0 8px 32px rgba(255,255,255,0.08); }
        .card-hover:hover { background: rgba(124,58,237,0.04) !important; }

        @media (max-width: 768px) {
          .hero-h1 { font-size: 40px !important; letter-spacing: -1.5px !important; }
          .hero-sub { font-size: 14px !important; }
          .hero-desc { font-size: 14px !important; }
          .hero-cta { font-size: 13px !important; padding: 12px 28px !important; }
          .nav-desktop { display: none !important; }
          .nav-mobile { display: flex !important; }
          .section-pad { padding-left: 20px !important; padding-right: 20px !important; }
          .grid-4 { grid-template-columns: 1fr 1fr !important; }
          .grid-3 { grid-template-columns: 1fr !important; }
          .stats-grid { grid-template-columns: 1fr 1fr !important; gap: 24px !important; }
          .footer-grid { grid-template-columns: 1fr !important; gap: 32px !important; }
          .footer-bottom { flex-direction: column !important; gap: 8px !important; text-align: center !important; }
          .trust-row { flex-wrap: wrap !important; gap: 16px !important; justify-content: center !important; }
          .cta-h2 { font-size: 28px !important; }
          .section-h2 { font-size: 26px !important; }
          .consistency-h2 { font-size: 24px !important; }
          .hero-buttons { flex-direction: column !important; align-items: center !important; }
          .strip-text { font-size: 8px !important; letter-spacing: 1px !important; }
          .nav-bar { padding: 14px 20px !important; }
          .hero-section { padding-top: 130px !important; padding-bottom: 72px !important; }
        }

        @media (max-width: 480px) {
          .hero-h1 { font-size: 32px !important; }
          .grid-4 { grid-template-columns: 1fr !important; }
          .stats-grid { grid-template-columns: 1fr 1fr !important; }
        }
      `}</style>

      {/* ═══ NAV ═══ */}
      <nav className="nav-bar" style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '18px 48px', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 50,
        background: 'rgba(10,10,10,0.8)', backdropFilter: 'blur(24px)', WebkitBackdropFilter: 'blur(24px)',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }} onClick={function() { window.location.href = 'https://groovie.live'; }} title="Groovie home">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="url(#lg)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <defs><linearGradient id="lg" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stopColor="#a78bfa"/><stop offset="100%" stopColor="#7c3aed"/></linearGradient></defs>
            <circle cx="5.5" cy="17.5" r="2.5"/><circle cx="17.5" cy="15.5" r="2.5"/><path d="M8 17V5l12-2v12"/>
          </svg>
          <span style={{ fontSize: 20, fontWeight: 700, letterSpacing: '-0.5px', color: '#fff' }}>groovie</span>
          <span style={{ fontSize: 9, fontWeight: 600, letterSpacing: '2.5px', textTransform: 'uppercase', color: 'rgba(255,255,255,0.25)', marginLeft: -2, marginTop: 2 }}>business</span>
        </div>

        {/* Desktop nav */}
        <div className="nav-desktop" style={{ display: 'flex', gap: 28, alignItems: 'center' }}>
          {navLink('Pricing', '/pricing')}
          {navLink('FAQ', '/faq')}
          {navLink('groovie.live', 'https://groovie.live', true)}
          <div style={{ width: 1, height: 16, background: 'rgba(255,255,255,0.08)' }} />
          {isLoggedIn ? (
            <button onClick={function() { navigate('/dashboard'); }} style={{
              padding: '8px 20px', borderRadius: 8, border: '1px solid rgba(124,58,237,0.4)',
              background: 'rgba(124,58,237,0.1)', color: '#c4b5fd', fontSize: 13, fontWeight: 600,
              cursor: 'pointer', fontFamily: f,
            }}>Dashboard</button>
          ) : (
            <>
              <button onClick={function() { navigate('/login'); }} style={{
                padding: '8px 20px', borderRadius: 8, border: '1px solid rgba(255,255,255,0.08)',
                background: 'transparent', color: 'rgba(255,255,255,0.6)', fontSize: 13, fontWeight: 500,
                cursor: 'pointer', fontFamily: f,
              }}>Sign in</button>
              <button onClick={function() { navigate('/register'); }} style={{
                padding: '8px 20px', borderRadius: 8, border: 'none',
                background: '#fff', color: '#0a0a0a', fontSize: 13, fontWeight: 600,
                cursor: 'pointer', fontFamily: f,
              }}>Get started</button>
            </>
          )}
        </div>

        {/* Mobile nav */}
        <div className="nav-mobile" style={{ display: 'none', gap: 10, alignItems: 'center' }}>
          {isLoggedIn ? (
            <button onClick={function() { navigate('/dashboard'); }} style={{
              padding: '8px 16px', borderRadius: 8, border: 'none',
              background: 'rgba(124,58,237,0.15)', color: '#c4b5fd', fontSize: 12, fontWeight: 600,
              cursor: 'pointer', fontFamily: f,
            }}>Dashboard</button>
          ) : (
            <>
              <button onClick={function() { navigate('/login'); }} style={{
                padding: '8px 14px', borderRadius: 8, border: '1px solid rgba(255,255,255,0.08)',
                background: 'transparent', color: 'rgba(255,255,255,0.6)', fontSize: 12, fontWeight: 500,
                cursor: 'pointer', fontFamily: f,
              }}>Sign in</button>
              <button onClick={function() { navigate('/register'); }} style={{
                padding: '8px 14px', borderRadius: 8, border: 'none',
                background: '#fff', color: '#0a0a0a', fontSize: 12, fontWeight: 600,
                cursor: 'pointer', fontFamily: f,
              }}>Get started</button>
            </>
          )}
        </div>
      </nav>

      {/* ═══ HERO ═══ */}
      <section className="hero-section section-pad" style={{ position: 'relative', paddingTop: 180, paddingBottom: 120, textAlign: 'center', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: -100, left: '50%', transform: 'translateX(-50%)', width: 900, height: 600, background: 'radial-gradient(ellipse at center, rgba(124,58,237,0.1) 0%, transparent 60%)', pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', top: 100, left: '25%', width: 400, height: 400, background: 'radial-gradient(circle, rgba(167,139,250,0.05) 0%, transparent 60%)', pointerEvents: 'none' }} />

        <div style={{ position: 'relative', maxWidth: 760, margin: '0 auto', padding: '0 20px' }}>
          <p className="hero-sub" style={{ fontSize: 12, fontWeight: 600, letterSpacing: '3px', textTransform: 'uppercase', color: 'rgba(255,255,255,0.45)', marginBottom: 40 }}>
            Radio as a Service · Autonomous Radio Infrastructure
          </p>

          <h1 className="hero-h1" style={{
            fontSize: 72, fontWeight: 700, margin: '0 0 24px',
            letterSpacing: '-3px', lineHeight: 0.95,
            background: 'linear-gradient(180deg, #ffffff 30%, rgba(255,255,255,0.5) 100%)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
          }}>
            The sound your<br />business deserves
          </h1>

          <p className="hero-desc" style={{
            fontSize: 16, color: 'rgba(255,255,255,0.55)', margin: '0 auto 20px',
            lineHeight: 1.8, maxWidth: 520, fontWeight: 400, letterSpacing: '0.2px',
          }}>
            Groovie Business gives you more than background music. It gives your business
            a fully customized radio station — built around your brand, your message, and your audience.
          </p>

          <p style={{
            fontSize: 15, color: 'rgba(255,255,255,0.7)', margin: '0 auto 48px',
            lineHeight: 1.7, maxWidth: 480, fontWeight: 500, letterSpacing: '-0.1px',
          }}>
            $89 per location, per month — with unlimited zones. Optimize how your business communicates, sounds, and shows up every day.
          </p>

          <div className="hero-buttons" style={{ display: 'flex', gap: 12, justifyContent: 'center', marginBottom: 64 }}>
            <button className="btn-hover hero-cta" onClick={function() { navigate(isLoggedIn ? '/dashboard' : '/register'); }} style={{
              padding: '14px 36px', borderRadius: 10, border: 'none',
              background: '#fff', color: '#0a0a0a', fontSize: 14, fontWeight: 600,
              cursor: 'pointer', fontFamily: f, letterSpacing: '-0.2px', transition: 'all 0.2s',
            }}>
              {isLoggedIn ? 'Open dashboard' : 'Start free trial'}
            </button>
            <button className="hero-cta" onClick={function() { navigate('/pricing'); }} style={{
              padding: '14px 36px', borderRadius: 10,
              border: '1px solid rgba(255,255,255,0.15)',
              background: 'transparent', color: 'rgba(255,255,255,0.6)', fontSize: 14, fontWeight: 500,
              cursor: 'pointer', fontFamily: f,
            }}>View plans</button>
          </div>

          <div className="trust-row" style={{ display: 'flex', justifyContent: 'center', gap: 32 }}>
            {['No credit card required', 'Typically live the same day', 'Unlimited zones', 'Cancel at end of paid month'].map(function(t) {
              return (
                <span key={t} style={{ fontSize: 11, fontWeight: 500, color: 'rgba(255,255,255,0.3)', display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span style={{ width: 4, height: 4, borderRadius: '50%', background: 'rgba(124,58,237,0.6)' }} />
                  {t}
                </span>
              );
            })}
          </div>
        </div>
      </section>

      {/* ═══ BRANDING STRIP ═══ */}
      <div className="section-pad" style={{
        borderTop: '1px solid rgba(255,255,255,0.04)', borderBottom: '1px solid rgba(255,255,255,0.04)',
        padding: '18px 48px', textAlign: 'center', background: 'rgba(255,255,255,0.01)',
      }}>
        <span className="strip-text" style={{ fontSize: 10, fontWeight: 500, letterSpacing: '2px', textTransform: 'uppercase', color: 'rgba(255,255,255,0.2)' }}>
          Simple &nbsp; &middot; &nbsp; Autonomous &nbsp; &middot; &nbsp; Always On &nbsp; &middot; &nbsp; No DJs &nbsp; &middot; &nbsp; No Manual Scheduling &nbsp; &middot; &nbsp; One Simple Price
        </span>
      </div>

      {/* ═══ TURN AUDIO INTO BRANDING ═══ */}
      <section className="section-pad" style={{ maxWidth: 1100, margin: '0 auto', padding: '96px 48px 40px' }}>
        <div style={{ marginBottom: 64, maxWidth: 520 }}>
          <p style={{ fontSize: 10, fontWeight: 600, letterSpacing: '3px', textTransform: 'uppercase', color: '#7c3aed', marginBottom: 14 }}>Your Station, Your Way</p>
          <h2 className="section-h2" style={{ fontSize: 36, fontWeight: 700, color: '#fff', margin: '0 0 14px', letterSpacing: '-1.2px', lineHeight: 1.1 }}>
            Turn everyday audio into<br />a branding channel
          </h2>
          <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.45)', margin: 0, lineHeight: 1.7 }}>
            With Groovie Business, your location becomes a live audio experience. Your customers don't just hear music. They hear your brand.
          </p>
        </div>

        <div className="grid-4" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 1, background: 'rgba(255,255,255,0.04)', borderRadius: 16, overflow: 'hidden' }}>
          {[
            { title: 'Your Branded Station', desc: 'A fully customized radio station for your business. Choose your genres, set the mood, and create the sonic identity your customers associate with your brand.', icon: 'M9 18V5l12-2v13M6 18a3 3 0 1 0 0-6M18 16a3 3 0 1 0 0-6' },
            { title: 'Your Announcements', desc: 'Communicate directly with customers through studio-quality voice announcements. Promote offers, share updates, or welcome guests — on your schedule.', icon: 'M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3zM19 10v2a7 7 0 0 1-14 0v-2M12 19v4' },
            { title: 'Your Custom Jingles', desc: 'Original jingles composed for your business. Reinforce brand recall with sonic identity that plays between music, before announcements, and during transitions.', icon: 'M9 11l3 3L22 4M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11' },
            { title: 'Your Industry News', desc: 'Keep customers informed with automated news and updates relevant to your industry. Delivered through your station, reinforcing your expertise and authority.', icon: 'M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 0-2 2zM10 2v20' },
          ].map(function(item, i) {
            return (
              <div key={i} className="card-hover" style={{ background: '#0a0a0a', padding: '36px 26px', transition: 'background 0.3s' }}>
                <div style={{
                  width: 36, height: 36, borderRadius: 9, marginBottom: 16,
                  background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.07)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(167,139,250,0.8)',
                }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d={item.icon}/></svg>
                </div>
                <h3 style={{ fontSize: 15, fontWeight: 600, color: 'rgba(255,255,255,0.9)', margin: '0 0 8px', letterSpacing: '-0.2px' }}>{item.title}</h3>
                <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.35)', margin: 0, lineHeight: 1.7 }}>{item.desc}</p>
              </div>
            );
          })}
        </div>
      </section>

      {/* ═══ PLATFORM CAPABILITIES ═══ */}
      <section className="section-pad" style={{ maxWidth: 1100, margin: '0 auto', padding: '56px 48px 80px' }}>
        <div className="grid-4" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 1, background: 'rgba(255,255,255,0.04)', borderRadius: 16, overflow: 'hidden' }}>
          {[
            { title: 'Rights-controlled catalog', desc: "Groovie's rights-controlled, Groovie-produced catalog, cleared for distribution through Groovie. Your subscription covers Groovie-supplied programming only — not music you supply or play separately.", icon: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' },
            { title: 'Business Intelligence', desc: 'Listener analytics, peak hours, and engagement data. Understand your audio environment and prove ROI on your sonic branding.', icon: 'M18 20V10M12 20V4M6 20v-6' },
            { title: 'Multi-Location Management', desc: 'One dashboard for every location — centralized control, per-location channels, and announcements targeted to one location or all.', icon: 'M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0zM12 7v0' },
          ].map(function(item, i) {
            return (
              <div key={i} className="card-hover" style={{ background: '#0a0a0a', padding: '36px 26px', transition: 'background 0.3s' }}>
                <div style={{
                  width: 36, height: 36, borderRadius: 9, marginBottom: 16,
                  background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.07)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(167,139,250,0.8)',
                }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d={item.icon}/></svg>
                </div>
                <h3 style={{ fontSize: 15, fontWeight: 600, color: 'rgba(255,255,255,0.9)', margin: '0 0 8px', letterSpacing: '-0.2px' }}>{item.title}</h3>
                <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.35)', margin: 0, lineHeight: 1.7 }}>{item.desc}</p>
              </div>
            );
          })}
        </div>
      </section>

      {/* ═══ CONSISTENCY SECTION ═══ */}
      <div className="section-pad" style={{
        borderTop: '1px solid rgba(255,255,255,0.04)', borderBottom: '1px solid rgba(255,255,255,0.04)',
        padding: '72px 48px', background: 'rgba(255,255,255,0.015)', textAlign: 'center',
      }}>
        <div style={{ maxWidth: 600, margin: '0 auto' }}>
          <p style={{ fontSize: 10, fontWeight: 600, letterSpacing: '3px', textTransform: 'uppercase', color: '#7c3aed', marginBottom: 16 }}>Consistency at Scale</p>
          <h2 className="consistency-h2" style={{ fontSize: 32, fontWeight: 700, color: '#fff', margin: '0 0 16px', letterSpacing: '-1px', lineHeight: 1.15 }}>
            Built for businesses that care about consistency
          </h2>
          <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.45)', margin: '0 0 12px', lineHeight: 1.7 }}>
            Whether you run one location or hundreds, Groovie Business keeps your message consistent across every space where customers walk in.
          </p>
          <p style={{ fontSize: 16, fontWeight: 600, color: 'rgba(255,255,255,0.65)', margin: 0, fontStyle: 'italic' }}>
            Your customers don't just hear music. They hear your brand.
          </p>
        </div>
      </div>

      {/* ═══ NUMBERS ═══ */}
      <div className="section-pad" style={{ padding: '64px 48px' }}>
        <div className="stats-grid" style={{ maxWidth: 900, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 48, textAlign: 'center' }}>
          {[
            { n: '$89', l: 'per location / month', s: 'Unlimited zones' },
            { desc: 'Afrobeats, gospel, Caribbean, Latin, jazz, R&B, hip hop & more', l: 'curated music styles', s: 'Every genre backed by real tracks' },
            { n: '700+', l: 'tracks in the catalog', s: 'Rights-controlled, Groovie-produced' },
            { n: '24/7', l: 'fully autonomous', s: 'No DJs. No manual work.' },
          ].map(function(s, i) {
            return (
              <div key={i}>
                {s.desc ? (
                  <p style={{ fontSize: 16, fontWeight: 700, color: '#fff', margin: '0 0 4px', lineHeight: 1.3, minHeight: 46, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{s.desc}</p>
                ) : (
                  <p style={{ fontSize: 42, fontWeight: 700, color: '#fff', margin: '0 0 4px', letterSpacing: '-2px' }}>{s.n}</p>
                )}
                <p style={{ fontSize: 12, fontWeight: 500, color: 'rgba(255,255,255,0.5)', margin: '0 0 2px' }}>{s.l}</p>
                <p style={{ fontSize: 10, color: 'rgba(255,255,255,0.2)', margin: 0 }}>{s.s}</p>
              </div>
            );
          })}
        </div>
      </div>

      {/* ═══ PLANS PREVIEW ═══ */}
      <section className="section-pad" style={{ maxWidth: 1000, margin: '0 auto', padding: '40px 48px 80px' }}>
        <div style={{ textAlign: 'center', marginBottom: 56 }}>
          <p style={{ fontSize: 10, fontWeight: 600, letterSpacing: '3px', textTransform: 'uppercase', color: '#7c3aed', marginBottom: 14 }}>Pricing</p>
          <h2 className="section-h2" style={{ fontSize: 36, fontWeight: 700, color: '#fff', margin: '0 0 8px', letterSpacing: '-1.2px' }}>One plan. Everything included.</h2>
          <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.4)', margin: 0 }}>Music, announcements, analytics, and your compliance dashboard — one price, unlimited zones.</p>
        </div>
        <div style={{ maxWidth: 420, margin: '0 auto', background: 'rgba(124,58,237,0.04)', border: '1px solid rgba(124,58,237,0.25)', borderRadius: 16, padding: '36px 28px', textAlign: 'center' }}>
          <p style={{ fontSize: 13, fontWeight: 600, color: '#c4b5fd', margin: '0 0 4px' }}>Groovie for Business</p>
          <div style={{ marginBottom: 2 }}>
            <span style={{ fontSize: 48, fontWeight: 700, color: '#fff', letterSpacing: '-2px' }}>$89</span>
            <span style={{ fontSize: 14, color: 'rgba(255,255,255,0.3)', marginLeft: 4 }}>/location/mo</span>
          </div>
          <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.3)', margin: '0 0 24px' }}>Unlimited zones · one simple price</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 28, textAlign: 'left' }}>
            {['Your branded radio station', 'Unlimited zones per location', "Groovie's rights-controlled, Groovie-produced catalog, cleared for distribution through Groovie", 'AI announcements', 'Calendar automation', 'Analytics, QR codes & compliance dashboard'].map(function(item) {
              return (
                <div key={item} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: 'rgba(255,255,255,0.6)' }}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#a78bfa" strokeWidth="2" style={{ flexShrink: 0 }}><polyline points="20,6 9,17 4,12"/></svg>
                  {item}
                </div>
              );
            })}
          </div>
          <button onClick={function() { navigate(isLoggedIn ? '/billing' : '/register'); }} style={{
            width: '100%', padding: '12px', borderRadius: 8, fontSize: 13, fontWeight: 600,
            cursor: 'pointer', fontFamily: f, border: 'none', background: '#fff', color: '#0a0a0a',
          }}>{isLoggedIn ? 'Subscribe' : 'Get started'}</button>
        </div>
        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <a href="/pricing" className="footer-link" style={{ fontSize: 12, color: 'rgba(255,255,255,0.3)', textDecoration: 'none', transition: 'color 0.2s' }}>
            Compare plans in detail &rarr;
          </a>
        </div>
      </section>

      {/* ═══ CTA ═══ */}
      <section className="section-pad" style={{ textAlign: 'center', padding: '96px 48px', position: 'relative', borderTop: '1px solid rgba(255,255,255,0.04)' }}>
        <div style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', width: 500, height: 300, background: 'radial-gradient(ellipse, rgba(124,58,237,0.07) 0%, transparent 65%)', pointerEvents: 'none' }} />
        <div style={{ position: 'relative', maxWidth: 560, margin: '0 auto' }}>
          <p style={{ fontSize: 10, fontWeight: 600, letterSpacing: '3px', textTransform: 'uppercase', color: 'rgba(255,255,255,0.25)', marginBottom: 20 }}>Get Started Today</p>
          <h2 className="cta-h2" style={{ fontSize: 40, fontWeight: 700, color: '#fff', margin: '0 0 14px', letterSpacing: '-1.5px', lineHeight: 1.1 }}>
            Start your business<br />radio station
          </h2>
          <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.45)', margin: '0 0 8px', lineHeight: 1.7 }}>
            Create your own branded radio experience — for $89 per location / month.
          </p>
          <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.35)', margin: '0 0 36px' }}>
            Your industry. Your announcements. Your sound.
          </p>
          <button className="btn-hover" onClick={function() { navigate(isLoggedIn ? '/dashboard' : '/register'); }} style={{
            padding: '14px 40px', borderRadius: 10, border: 'none',
            background: '#fff', color: '#0a0a0a', fontSize: 14, fontWeight: 600,
            cursor: 'pointer', fontFamily: f, letterSpacing: '-0.2px', transition: 'all 0.2s',
          }}>{isLoggedIn ? 'Open dashboard' : 'Start free trial'}</button>
          <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.2)', marginTop: 20 }}>Autonomous radio for modern businesses.</p>
        </div>
      </section>

      {/* ═══ FOOTER ═══ */}
      <footer className="section-pad" style={{ borderTop: '1px solid rgba(255,255,255,0.04)', padding: '48px 48px 36px' }}>
        <div className="footer-grid" style={{ maxWidth: 1100, margin: '0 auto', display: 'grid', gridTemplateColumns: '2.5fr 1fr 1fr 1fr', gap: 48 }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="url(#lg2)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <defs><linearGradient id="lg2" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stopColor="#a78bfa"/><stop offset="100%" stopColor="#7c3aed"/></linearGradient></defs>
                <circle cx="5.5" cy="17.5" r="2.5"/><circle cx="17.5" cy="15.5" r="2.5"/><path d="M8 17V5l12-2v12"/>
              </svg>
              <span style={{ fontSize: 16, fontWeight: 700, color: '#fff', letterSpacing: '-0.3px' }}>groovie</span>
              <span style={{ fontSize: 8, fontWeight: 600, color: 'rgba(255,255,255,0.2)', letterSpacing: '2px', textTransform: 'uppercase' }}>business</span>
            </div>
            <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.3)', lineHeight: 1.8, maxWidth: 300, margin: 0 }}>
              Autonomous radio for modern businesses. Your brand, your voice, your station — delivered automatically, without DJs, playlists, or manual scheduling.
            </p>
          </div>
          {[
            { title: 'Platform', links: [
              { label: 'Dashboard', href: '/dashboard' },
              { label: 'Pricing', href: '/pricing' },
              { label: 'FAQ', href: '/faq' },
              { label: 'Sign in', href: '/login' },
              { label: 'Register', href: '/register' },
            ]},
            { title: 'Product', links: [
              { label: 'groovie.live', href: 'https://groovie.live', ext: true },
              { label: 'Music Catalog', href: '/pricing' },
              { label: 'Content Library', href: '/faq' },
              { label: 'Ad Platform', href: '/pricing' },
            ]},
            { title: 'Legal', links: [
              { label: 'Terms of Service', href: '/terms' },
              { label: 'Privacy Policy', href: '/privacy' },
              // License Agreement + Compliance are counsel-controlled, login-gated pages (/license,
              // /compliance). Not linked from the public footer: sending a logged-out prospect to a
              // login wall reads worse than omitting it, and the retired-tier placeholder is now removed.
            ]},
          ].map(function(section) {
            return (
              <div key={section.title}>
                <p style={{ fontSize: 10, fontWeight: 600, color: 'rgba(255,255,255,0.35)', letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: 16 }}>{section.title}</p>
                {section.links.map(function(link) {
                  return (
                    <a key={link.label} href={link.href} target={link.ext ? '_blank' : undefined} rel={link.ext ? 'noopener noreferrer' : undefined}
                      className="footer-link"
                      style={{ display: 'block', fontSize: 12, color: 'rgba(255,255,255,0.25)', textDecoration: 'none', marginBottom: 10, transition: 'color 0.15s' }}
                    >{link.label}</a>
                  );
                })}
              </div>
            );
          })}
        </div>
        <div className="footer-bottom" style={{ maxWidth: 1100, margin: '36px auto 0', paddingTop: 20, borderTop: '1px solid rgba(255,255,255,0.04)', display: 'flex', justifyContent: 'space-between' }}>
          <p style={{ fontSize: 10, color: 'rgba(255,255,255,0.15)', margin: 0 }}>{'\u00A9'} {new Date().getFullYear()} Gooverio Labs LLC. All rights reserved.</p>
          <p style={{ fontSize: 10, color: 'rgba(255,255,255,0.1)', margin: 0 }}>Groovie Business. Autonomous radio for modern businesses.</p>
        </div>
      </footer>
    </div>
  );
}
